import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { isEqual, includes, uniq } from 'lodash';

import toggleInArray from 'component-lib/toggleInArray';
import RolesModalComponent, { ALL_CHECKBOX } from 'v-c/Modals/Components/RolesModal';

const modalOptions = {
    selectedRoles: PropTypes.array.isRequired,
    disabledRole: PropTypes.bool.isRequiried,
    userRoles: PropTypes.array.isRequired,
    bulkOptions: PropTypes.shape({
        addRoles: PropTypes.func.isRequired,
        removeRoles: PropTypes.func.isRequired,
    }),
    individualOptions: PropTypes.shape({
        updateRoles: PropTypes.func.isRequired,
    }),
};

export default class RolesModal extends Component {
    static propTypes = {
        closeModal: PropTypes.func.isRequired,
        modalOptions: PropTypes.shape(modalOptions),
        modal: PropTypes.shape({
            type: PropTypes.string.isRequired,
            options: PropTypes.shape(modalOptions),
        }),
    };

    static defaultProps = {
        modalOptions: null,
        modal: null,
    };

    constructor(props) {
        super(props);

        const { selectedRoles = [] } = this.modalOptions;

        this.state = {
            selectedRoles,
            originalSelectedRoles: selectedRoles,
        };
    }

    onClickCheckbox = (cellId, newValue) => {
        let selectedRoles = toggleInArray(this.state.selectedRoles, cellId);

        if (cellId === ALL_CHECKBOX) {
            selectedRoles = newValue ? this.allRolesName : this.allUnselectedRoles;
        }

        this.setState({ selectedRoles });
    };

    get allRolesName() {
        return this.modalOptions.userRoles
            .map(({ id }) => id)
            .filter(role => !includes(this.modalOptions.protectedRoles, role) ||
          includes(this.modalOptions.selectedRoles, role),);
    }

    get allUnselectedRoles() {
        return [
            ...this.modalOptions.protectedRoles.filter(role => includes(this.modalOptions.selectedRoles, role),),
        ];
    }

    get modalOptions() {
        return this.props.modalOptions || this.props.modal.options;
    }

    get isBulkButtonDisabled() {
        return !this.state.selectedRoles.length;
    }

    get isUpdateButtonDisabled() {
        return isEqual(this.state.selectedRoles.sort(), this.state.originalSelectedRoles.sort());
    }

    get isAllSelected() {
        return (
            this.modalOptions.userRoles.length ===
      uniq([...this.state.selectedRoles, ...(this.modalOptions.protectedRoles || [])]).length
        );
    }

    get preparedUserRoles() {
        return this.modalOptions.userRoles.map(({ id, isProtected }) => ({
            id,
            isChecked: includes(this.state.selectedRoles, id),
            isDisabled: this.modalOptions.disabledRole === id,
            isProtected,
            forceHover: false,
        }));
    }

    render() {
        const { closeModal } = this.props;
        const { bulkOptions, individualOptions } = this.modalOptions;
        const { selectedRoles } = this.state;

        return (
            <RolesModalComponent
                bulkOptions={bulkOptions}
                individualOptions={individualOptions}
                closeModal={closeModal}
                onClickCheckbox={this.onClickCheckbox}
                isAllSelected={this.isAllSelected}
                isBulkButtonDisabled={this.isBulkButtonDisabled}
                isUpdateButtonDisabled={this.isUpdateButtonDisabled}
                preparedUserRoles={this.preparedUserRoles}
                tempSelectedRoles={selectedRoles}
            />
        );
    }
}
